import { onMounted, ref } from "@vue/composition-api"

export const getClassifyList = (props, ctx, query, log) => {
  let items = ref()
  onMounted(() => {
    ctx.root.$lazy("classifyList").then((d) => {
      if (query.size) {
        items.value = d.slice(0, query.size)
      } else {
        items.value = [{ id: 0, name: ctx.root.$t("全部") }, ...d]
      }
      // if (log) {
      //   console.log(d)
      // }
    })
  })
  return items
}
